import React from 'react'
import { SortableContainer } from 'react-sortable-hoc'
import { Row } from 'antd'

// import Paragraph from './node/Paragraph'
import Image from './node/Image'
import Video from './node/Video'
import Youtube from './node/Youtube'
import Link from './node/Link'

function Comp (
    {
        action,
        contents = [],
        createTemp,

        onChange,
        onUploading,
    }
)
{
    return (
        <Row type="flex" >
            {
                contents.map((content, i) =>
                {
                    if (content.type === 'video')
                    {
                        return (
                            <Video
                                key={content.id}
                                // id={content.id}
                                index={i}
                                sortIndex={i}
                                length={contents.length}
                                onChange={onChange}
                                onUploading={onUploading}
                                action={action}
                                createTemp={createTemp}
                                {...content}
                            />
                        )
                    }
                    else if (content.type === 'youtube')
                    {
                        return (
                            <Youtube
                                key={content.id}
                                // id={content.id}
                                index={i}
                                sortIndex={i}
                                length={contents.length}
                                onChange={onChange}
                                onUploading={onUploading}
                                action={action}
                                createTemp={createTemp}
                                {...content}
                            />
                        )
                    }
                    else if (content.type === 'link')
                    {
                        return (
                            <Link
                                key={content.id}
                                // id={content.id}
                                index={i}
                                sortIndex={i}
                                length={contents.length}
                                onChange={onChange}
                                onUploading={onUploading}
                                action={action}
                                createTemp={createTemp}
                                {...content}
                            />
                        )
                    }

                    return (
                        <Image
                            key={content.id}
                            // id={content.id}
                            index={i}
                            sortIndex={i}
                            length={contents.length}
                            onChange={onChange}
                            onUploading={onUploading}
                            action={action}
                            createTemp={createTemp}
                            {...content}
                        />
                    )
                })
                .filter (e => !!e)
            }
        </Row>
    )
}

export default SortableContainer(Comp)